<template>
  <div class="ticket">
    <div class="left-containers">
      <div class="upper-container">
        <div style="display: flex; flex-direction: row; gap: 12px; align-items: center">
          <img
            src="../../../../public/assets/CoreEvent-logo-black.svg"
            alt="CoreEvent Logo"
            style="width: 60px; height: 60px"
          >
          <span class="invoice-id">
            Račun broj:
            {{ getInvoiceNumber }}
          </span>
        </div>
        <div style="display: flex; flex-direction: column; text-align: right">
          <span id="not-ticket-hr">OVO NIJE ULAZNICA.</span>
          <span id="not-ticket">Not a ticket.</span>
        </div>
      </div>
      <span id="title-name">
        Naziv događaja: <span id="title">{{ eventInfo.eventTitle }}</span>
      </span>
      <table>
        <tr style="border-bottom: 0.5px solid black">
          <th>#</th>
          <th>Naziv</th>
          <th>Količina</th>
          <th>Stopa PDV-a</th>
          <th>Jed. cijena s PDV-om</th>
          <th>Ukupno s PDV-om</th>
        </tr>
        <tr
          v-for="(ticket, index) in countDuplicate()"
          :key="index"
          style="border-bottom: 0.5px solid grey"
        >
          <td>{{ index + 1 }}.</td>
          <td>
            {{ ticket.orderItem.name }}
          </td>
          <td>
            {{ ticket.count }}
          </td>
          <td>{{ parseInt(ticket.orderItem.id) === 9963 ? 25 : vatPercentage }}%</td>
          <td>
            {{ getDiscountedItemPrice(ticket.orderItem.price) }}
            EUR
          </td>
          <td>
            {{ (Number(getDiscountedItemPrice(ticket.orderItem.price)) * ticket.count).toFixed(2) }}
            EUR
          </td>
        </tr>
        <tr
          v-for="(fee, index) in fixedFeeItems"
          v-if="fixedFeeItems.length"
          :key="fee.name"
          style="border-bottom: 0.5px solid black"
        >
          <td>{{ countDuplicate().length + 1 + index }}.</td>
          <td>{{ fee.name }}</td>
          <td>
            {{ fee.count }}
          </td>
          <td>25%</td>
          <td>
            {{ fee.singleItemPrice }}
            EUR
          </td>
          <td>
            {{ fee.totalPrice }}
            EUR
          </td>
        </tr>
        <tr>
          <td colspan="5">Sveukupno:</td>
          <td>
            {{ getTotalPrice() }}
            EUR
          </td>
        </tr>
      </table>
    </div>
    <div class="right-containers">
      <div
        style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 1rem"
      >
        <div style="display: flex; flex-direction: column">
          <span>*Izdano u ime i za račun organizatora:</span>
          <span>
            {{ organization.legalName }} , {{ organization.address }}, OIB: {{ organization.OIB }}
          </span>
          <span style="height: 120px">
            {{
              organization.VATObligor
                ? 'Organizator je u sustavu PDV-a prema čl. 90, st. 1 i 2 Zakona o PDV-u. Ulaznica vrijedi kao račun.'
                : 'Organizator nije u sustavu PDV-a prema čl. 90, st. 1 i 2 Zakona o PDV-u. Ulaznica vrijedi kao račun.'
            }}
          </span>
          <span>Ulaznica vrijedi kao račun. Način plaćanja: {{ paymentMethodLabel }}.</span>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; margin-right: 30px; gap: 8px">
        <canvas ref="qrcode" class="qrcode" />
        <div style="display: flex; flex-direction: column">
          <span>Račun broj: {{ getInvoiceNumber }} Izdan: {{ getPublishedTime }}</span>
          <span>U ime i za račun organizatora izdao: CoreEvent d.o.o.,</span>
          <span>Dunjevac 15, 10000 Zagreb, Hrvatska</span>
          <span>JIR: {{ fiscalisationInfo.jir }}</span>
          <span>ZKI: {{ fiscalisationInfo.zki }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { round } from 'lodash'
import QRCode from 'qrcode'
import { CoreEventFeeType } from '@/types'
import { PaymentType } from '@/enums/payment-type'
import { convertUtcToCroatianLocalTime } from '@/utils'
import { invoicePaymentMethodLabel } from '@/utils/fiscal-payment-method'

export default {
  name: 'ticket-seller-ticket-invoice-pdf',
  props: [
    'fiscalisationInfo',
    'ticketSellerOrganization',
    'organization',
    'eventInfo',
    'purchasedAt',
    'ticketsInfo',
    'order',
    'buyer',
  ],
  data() {
    return {
      fixedFeeItems: [],
      totalCoreEventFee: 0,
    }
  },
  computed: {
    paymentMethodLabel() {
      return invoicePaymentMethodLabel(this.order, this.fiscalisationInfo)
    },
    vatPercentage() {
      if (this.eventInfo && this.eventInfo.VATPercentage != null) {
        return this.eventInfo.VATPercentage
      }

      return (this.organization && this.organization.VATPercentage) || 0
    },
    paymentType() {
      return (this.buyer && this.buyer.paymentType) || this.order.paymentType || null
    },
    getPublishedTime() {
      return moment(this.order.createdAt).format('DD.MM.YYYY HH:mm')
    },
    getInvoiceNumber() {
      if (this.fiscalisationInfo && this.fiscalisationInfo.full_receipt && this.fiscalisationInfo.full_receipt.designation) {
        const designation = this.fiscalisationInfo.full_receipt.designation
        if (designation.number && designation.location_id && designation.register_number) {
          return `${designation.number}-${designation.register_number}-${designation.location_id}`
        }
      }

      return `${this.order.invoiceNumber}-1-${
        moment(this.getPublishedTime, 'DD.MM.YYYY hh:mm').isAfter('2024/2/26 23:59') ? 12 : 10
      }`
    },
  },
  async mounted() {
    await this.generateQrCode(this.fiscalisationInfo)
    this.getCoreEventFee()
  },
  methods: {
    getDiscountedItemPrice(price) {
      const paymentType = this.paymentType
      const ticketPrice = Number(price)

      if (!paymentType) {
        return round(ticketPrice, 2)
      }

      const discountMultipliers = {
        [PaymentType.KEKS10]: 0.9,
        [PaymentType.TELEGRAM20]: 0.8,
        [PaymentType.POPUST20]: 0.8,
        [PaymentType.Popust40]: 0.6,
        [PaymentType.Popust50]: 0.5,
        [PaymentType.FREE]: 0,
        [PaymentType.CASH20]: 0.8,
        [PaymentType.CARD20]: 0.8,
        [PaymentType.CASH50]: 0.5,
        [PaymentType.CARD50]: 0.5,
      }

      const multiplier = discountMultipliers[paymentType]

      if (multiplier !== undefined) {
        return round(ticketPrice * multiplier, 2)
      }

      return round(ticketPrice, 2)
    },
    getTotalPrice() {
      return round(
        this.countDuplicate().reduce(
          (acc, curr) => (acc += curr.count * this.getDiscountedItemPrice(curr.orderItem.price)),
          0,
        ) + this.totalCoreEventFee,
        2,
      )
    },
    getCoreEventFee() {
      return (this.fixedFeeItems = this.fiscalisationInfo.fiscalisationError
        ? []
        : this.fiscalisationInfo.full_receipt.items
          .map(i => {
            if (i.name.includes(CoreEventFeeType.TICKET)) {
              this.totalCoreEventFee += i.price / 100

              return {
                name: i.name,
                count: i.amt / 1000,
                totalPrice: i.price / 100,
                singleItemPrice: i['single_item_price'] / 100,
              }
            }
          })
          .filter(Boolean))
    },
    async generateQrCode(data) {
      const canvas = this.$refs.qrcode
      const publishTime = this.buildPublishTime(data, this.order.createdAt)

      return QRCode.toDataURL(
        canvas,
        `https://porezna.gov.hr/rn?jir=${data.jir}&datv=${publishTime}&izn=${data.totalPrice}`,
        {
          width: 38,
          margin: 0,
        },
      )
    },
    countDuplicate() {
      return Object.values(
        this.ticketsInfo.reduce((r, e) => {
          let k = `${e.orderItem.id}`
          if (!r[k])
            r[k] = {
              ...e,
              count: 1,
            }
          else r[k].count += 1

          return r
        }, {}),
      )
    },
    buildPublishTime(data, createdAt) {
      if (data && data.publishTime) {
        return convertUtcToCroatianLocalTime(data.publishTime, 'YYYYMMDD_HHmm')
      }
      if (data && data.full_receipt && data.full_receipt.issue_date_time) {
        return moment.unix(data.full_receipt.issue_date_time).tz('Europe/Zagreb').format('YYYYMMDD_HHmm')
      }

      return convertUtcToCroatianLocalTime(moment(createdAt).format('YYYYMMDD_HHmm'), 'YYYYMMDD_HHmm')
    },
  },
}
</script>

<style scoped>
.ticket {
  display: flex;
  flex-direction: row;
  height: 70mm;
  width: 210mm;
}

.qrcode {
  margin-top: 1mm;
  height: 13mm !important;
  width: 13mm !important;
}

.left-containers {
  height: 100%;
  width: calc(210mm * 0.8);
  padding: 4mm 0 0 14mm;
}

.right-containers {
  background: transparent;
  height: 100%;
  padding-right: 22px;
  width: calc(210mm * (0.2));
  display: flex;
  flex-direction: column;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
}

.upper-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

.invoice-id {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%; /* 16.5px */
  letter-spacing: -0.3px;
}

#title {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 8px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -0.24px;
}

#title-name {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%; /* 8.8px */
  letter-spacing: -0.24px;
}

#not-ticket {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%;
  letter-spacing: -0.36px;
}

#not-ticket-hr {
  color: #333;
  text-align: right;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%; /* 13.2px */
  letter-spacing: -0.36px;
}

tr {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 8px;
  text-align: left;
  font-style: normal;
  font-weight: 400;
  line-height: 110%; /* 8.8px */
  letter-spacing: -0.24px;
}

th {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%; /* 8.8px */
}

table {
  width: 100%;
  border-collapse: collapse;
}

span {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 5px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%; /* 5.5px */
}

.ticket {
  display: flex;
  flex-direction: row;
  height: 70mm;
  width: 210mm;
}

.tearOffWrapper {
  height: 26px;
  width: 210mm;
  display: flex;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  font-size: 8px;
  line-height: 9px;
  color: #000;
}

.tearOff {
  margin-left: 90mm;
  margin-top: 10px;
}
</style>
